import { render } from "./SkillComponents.vue?vue&type=template&id=9dd9f3ce"
import script from "./SkillComponents.vue?vue&type=script&lang=js"
export * from "./SkillComponents.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dhaffaabdillah/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__